/*
  Complete, fast translation of the collection / search page content.

  Google Translate's page widget translates lazily (what is on screen first, the rest later or never) and does not
  translate the names inside dropdown menus. So on a translated visit this script takes the page content (#MainContent:
  the intro texts, the Top Rated / Most Rated buttons, the filter menus and every product, also those added later by
  filters, sorting and paging) out of the widget's hands (notranslate) and translates it itself, in a few batched
  requests to Google's translation service. Results are kept in localStorage, so a text is only translated once per
  language. The header and footer stay with the widget. If the service cannot be reached, everything is handed back.
*/
(function () {
  if (window.btfGridTranslate) return;
  window.btfGridTranslate = true;

  var m = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
  var lang = m ? decodeURIComponent(m[1]).split('/')[2] : '';
  if (!lang || lang === 'en') return;

  var ENDPOINT = 'https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&dt=t&tl=' + encodeURIComponent(lang) + '&q=';
  var CHUNK = 1500; /* characters of text per request (keeps the URL short) */
  var KEY = 'btf-tr1:' + lang;
  var SEP = '\n';
  var memo = {};
  try { memo = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { memo = {}; }
  var saveTimer = 0;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        var keys = Object.keys(memo);
        if (keys.length > 4000) keys.slice(0, keys.length - 4000).forEach(function (k) { delete memo[k]; });
        localStorage.setItem(KEY, JSON.stringify(memo));
      } catch (e) {}
    }, 400);
  }

  var MENUS = 'select[data-cv-filter]';
  var failed = false;

  function hold(el) {
    el.classList.add('notranslate');
    el.setAttribute('translate', 'no');
  }
  function release(el) {
    el.classList.remove('notranslate');
    el.removeAttribute('translate');
  }

  /* ---------- the translation service, batched ---------- */
  var waiting = {}; /* text -> [callbacks] */
  var queue = [];
  var flushTimer = 0;
  function request(texts) {
    return fetch(ENDPOINT + encodeURIComponent(texts.join(SEP)))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        var out = (data && data[0] || []).map(function (seg) { return seg && seg[0] || ''; }).join('').split(SEP);
        if (out.length !== texts.length) {
          /* the service merged / split lines: translate these one by one instead */
          if (texts.length === 1) return [out.join(' ')];
          return Promise.all(texts.map(function (t) { return request([t]).then(function (r) { return r[0]; }); }));
        }
        return out;
      });
  }
  function flush() {
    flushTimer = 0;
    var batch = queue.splice(0);
    var chunks = [], cur = [], size = 0;
    batch.forEach(function (t) {
      if (size + t.length > CHUNK && cur.length) { chunks.push(cur); cur = []; size = 0; }
      cur.push(t); size += t.length + 1;
    });
    if (cur.length) chunks.push(cur);
    chunks.forEach(function (texts) {
      request(texts).then(function (out) {
        texts.forEach(function (t, i) {
          var v = String(out[i] || '').trim();
          if (v) memo[t] = v;
          (waiting[t] || []).forEach(function (cb) { cb(v || t); });
          delete waiting[t];
        });
        save();
      }, function () {
        failed = true;
        texts.forEach(function (t) { (waiting[t] || []).forEach(function (cb) { cb(null); }); delete waiting[t]; });
        giveBack();
      });
    });
  }
  function translate(text, cb) {
    if (memo[text]) return cb(memo[text]);
    if (failed) return cb(null);
    if (waiting[text]) return waiting[text].push(cb);
    waiting[text] = [cb];
    queue.push(text);
    if (!flushTimer) flushTimer = setTimeout(flush, 30);
  }

  /* ---------- the page content (#MainContent): intro texts, sort buttons, filters, products ---------- */
  var SKIP = /^[\s\d.,:%$€£¥+\-–—/()*★☆|#]*$/; /* prices, counts, stars: nothing to translate */
  /* Never sent: what the theme keeps as it is (prices, ratings...), progress messages that change every moment, menus (below). */
  var KEEP = '.notranslate:not(#MainContent), [translate="no"]:not(#MainContent), .price, [class*="price"], .money, .rating-text, .metafield-sort-status, .cv-busy-badge, select, script, style, noscript, template';
  var mine = typeof WeakMap === 'function' ? new WeakMap() : null; /* text node -> the translation we wrote */
  function textNodes(root) {
    var list = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (SKIP.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (mine && mine.get(n) === n.nodeValue) return NodeFilter.FILTER_REJECT; /* already translated */
        var p = n.parentElement;
        if (!p || p.closest(KEEP) || p.closest('.cv-skeleton')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    while (walker.nextNode()) list.push(walker.currentNode);
    return list;
  }
  function translateNode(node) {
    var original = node.nodeValue;
    var lead = original.match(/^\s*/)[0], tail = original.match(/\s*$/)[0];
    var text = original.trim().replace(/\s+/g, ' ');
    if (!text) return;
    if (mine) mine.set(node, original); /* in progress: not picked again */
    translate(text, function (v) {
      if (v && node.nodeValue === original) {
        node.nodeValue = lead + v + tail;
        if (mine) mine.set(node, node.nodeValue);
      }
    });
  }
  function translateAttrs(root) {
    root.querySelectorAll('img[alt], input[placeholder], textarea[placeholder]').forEach(function (el) {
      var name = el.tagName === 'IMG' ? 'alt' : 'placeholder';
      if (el['__btf' + name]) return;
      var val = (el.getAttribute(name) || '').trim();
      if (!val || SKIP.test(val) || el.closest(KEEP)) return;
      el['__btf' + name] = 1;
      translate(val, function (v) { if (v) el.setAttribute(name, v); });
    });
  }
  /* A sentence with bold / italic words ("use our <strong>Top Rated</strong> and ...") is translated whole, so the
     grammar is right in the other language (the bold styling of those words is dropped on translated pages). */
  var INLINE = /^(STRONG|EM|B|I|U|SMALL)$/;
  function translateSentences(root) {
    root.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li').forEach(function (el) {
      if (el.__btfWhole || !el.children.length || el.closest(KEEP)) return;
      for (var i = 0; i < el.children.length; i++) {
        var c = el.children[i];
        if (!INLINE.test(c.tagName) || c.children.length) return;
      }
      var text = el.textContent.trim().replace(/\s+/g, ' ');
      if (!text || SKIP.test(text)) return;
      el.__btfWhole = 1;
      var nodes = [];
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      while (w.nextNode()) nodes.push(w.currentNode);
      if (mine) nodes.forEach(function (n) { mine.set(n, n.nodeValue); }); /* not picked one by one */
      translate(text, function (v) {
        if (!v) return;
        el.textContent = v;
        if (mine && el.firstChild) mine.set(el.firstChild, el.firstChild.nodeValue);
      });
    });
  }
  function translateMain(root) {
    translateSentences(root);
    textNodes(root).forEach(translateNode);
    translateAttrs(root);
  }

  /* ---------- Collection / Sub-collection menus ---------- */
  var COUNT = /^(.*?)(\s*\(\s*[\d.,\s]+\))?\s*$/;
  function translateOption(opt) {
    if (opt.disabled && !opt.value) return;
    var shown = opt.textContent;
    var parts = shown.match(COUNT);
    var name = (opt.__btfName || (parts && parts[1]) || '').trim();
    if (!name || SKIP.test(name)) return;
    if (opt.__btfName === name && opt.__btfDone === shown) return; /* already ours */
    opt.__btfName = name;
    var count = (parts && parts[2]) || '';
    translate(name, function (v) {
      if (!v || !opt.isConnected && !opt.parentNode) return;
      var now = opt.textContent.match(COUNT);
      var c = now && now[1].trim() === name ? (now[2] || '') : count;
      opt.textContent = v + c;
      opt.__btfDone = opt.textContent;
    });
  }
  function translateMenu(select) {
    hold(select);
    Array.prototype.forEach.call(select.options, translateOption);
  }

  /* ---------- hand back to the page widget if the service is unreachable ---------- */
  function giveBack() {
    document.querySelectorAll('#MainContent, ' + MENUS).forEach(release);
  }

  function scan() {
    if (failed) return;
    var main = document.getElementById('MainContent');
    if (main) translateMain(main);
    document.querySelectorAll(MENUS).forEach(translateMenu);
  }

  /* Hold everything at once (before the page widget starts), then translate. */
  document.querySelectorAll('#MainContent, ' + MENUS).forEach(hold);
  scan();

  /* Products added later (filters, sorting, paging, infinite scroll) and rebuilt menus. */
  if ('MutationObserver' in window) {
    var t = 0;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        var el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        if (!el) continue;
        if (el.closest('#MainContent') || el.querySelector && el.querySelector('#MainContent')) {
          clearTimeout(t);
          t = setTimeout(scan, 60);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
